import React from 'react'
import Icon from '../misc/Icons'

// Marks a search hit that came from one of the local engines, distinguishing
// Fuse from MiniSearch (BM25). Purely a quality-evaluation cue while the local
// engines run as shadows, so it is hidden in production; the hit markers
// themselves (__localOrigin / __localEngine) are set by the local providers.
function LocalBadge({ hit }) {
  if (process.env.REACT_APP_ENV === 'production') return null
  if (!hit || !hit.__localOrigin) return null
  if (hit.__localEngine === 'minisearch') {
    return <Icon name='local-source-bm25' className='searchResults-localBadge searchResults-localBadge--bm25' />
  }
  return <Icon name='fuse-source' className='searchResults-localBadge' />
}

export default LocalBadge
